import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import { clearAuthError } from './actions';
import './AuthModal.css';

const AUTH_TABS = {
    LOGIN: 'login',
    REGISTER: 'register',
};

const AuthModal = ({ open, onClose }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(AUTH_TABS.LOGIN);

    const handleClose = () => {
        setActiveTab(AUTH_TABS.LOGIN);
        dispatch(clearAuthError());
        onClose();
    };

    const handleSuccess = () => {
        handleClose();
        navigate('/profile');
    };

    const switchToRegister = () => {
        dispatch(clearAuthError());
        setActiveTab(AUTH_TABS.REGISTER);
    };

    const switchToLogin = () => {
        dispatch(clearAuthError());
        setActiveTab(AUTH_TABS.LOGIN);
    };

    return (
        <Modal
            open={open}
            onCancel={handleClose}
            footer={null}
            centered
            destroyOnHidden
            width={480}
            className="auth-modal"
            wrapClassName="auth-modal-wrap"
            zIndex={1100}
        >
            <div className="auth-modal-inner">
                <div className="auth-tabs">
                    <button
                        className={`auth-tab ${activeTab === AUTH_TABS.LOGIN ? 'active' : ''}`}
                        onClick={switchToLogin}
                    >
                        Вход
                    </button>
                    <button
                        className={`auth-tab ${activeTab === AUTH_TABS.REGISTER ? 'active' : ''}`}
                        onClick={switchToRegister}
                    >
                        Регистрация
                    </button>
                </div>

                <div className="auth-content">
                    {activeTab === AUTH_TABS.LOGIN ? (
                        <LoginForm
                            onSwitchToRegister={switchToRegister}
                            onSuccess={handleSuccess}
                        />
                    ) : (
                        <RegisterForm
                            onSwitchToLogin={switchToLogin}
                            onSuccess={handleSuccess}
                        />
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default AuthModal;